import { render, staticRenderFns } from "./AddReader.vue?vue&type=template&id=650b56b1&"
import script from "./AddReader.vue?vue&type=script&lang=ts&"
export * from "./AddReader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports